import axios from '@/axios.js';

export default {
  treatmentTypes(_context, data){
    return new Promise((resolve, reject) => {
      axios.get('/api/v1/treatmentTypes', { params: data })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => { reject(error); });
    });
  },
  treatmentTypesById(_context, payload){
    return new Promise((resolve, reject) => {
      axios.get('/api/v1/treatmentTypes/'+payload.id)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => { reject(error); });
    });
  },
  saveTreatmentTiming(_context, payload){
    return new Promise((resolve, reject) => {
      axios.post('/api/v1/treatmentTypes/'+payload.id+'/save', {data: payload.data})
        .then((response) => {
          resolve(response);
        })
        .catch((error) => { reject(error); });
    });
  },
};
